<template>
    <div>
        <div class="card-content-search"></div>
        <div class="card-content-table">
            <el-table
                    border
                    :data="tableList"
                    align="center"
                    style="width: 100%"
                    ref="table"
                    :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',
                    }"
                    :row-key="getRowKeys"
                    :expand-row-keys="expands">
                <el-table-column
                        label="序号"
                        type="index"
                        align="center"
                        width="50">
                    <template scope="scope">
                        <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="姓名"
                        align="center"
                        prop="empName">
                    <template scope="scope">
                        <p>{{scope.row.empName || "--"}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="身份证号"
                        align="center"
                        width="190"
                        prop="idNumber">
                    <template scope="scope">
                        <p>{{scope.row.idNumber || "--"}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="技术职称"
                        align="center"
                        prop="title">
                    <template scope="scope">
                        <p>{{scope.row.title || "--"}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="公司职务"
                        align="center"
                        prop="job">
                    <template scope="scope">
                        <p>{{scope.row.job || "--"}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="是否在职"
                        align="center"
                        prop="offJobName">
                </el-table-column>
                <el-table-column
                        label="数据来源"
                        align="center"
                        prop="comeFrom">
                </el-table-column>
                <el-table-column
                        label="数据状态"
                        align="center"
                        prop="state">
                    <template scope="scope">
                        <p type="text" v-if="scope.row.state == 1" class="change-examine"><i class="examine-effective"></i><span>有效</span></p>
                        <p type="text" v-else-if="scope.row.state == 2" class="change-examine"><i class="examine-waitSubmit"></i><span>待生效</span></p>
                        <p type="text" v-else-if="scope.row.state == 3" class="change-examine"><i class="examine-invalid"></i><span>已作废</span></p>
                        <p type="text" v-else-if="scope.row.state == 4" class="change-examine"><i class="examine-waitSubmit"></i><span>待提交</span></p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="登记日期"
                        align="center"
                        prop="createTime">
                    <template scope="scope">
                        <p>{{scope.row.createTime | dateStrIntercept}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="toogleExpand(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column type="expand" width="1">
                    <template slot-scope="props">
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  label-width="160px" style="position: relative" inline>
                            <el-row>
                                <el-col>
                                    <el-col :span="8">
                                        <el-form-item label="姓名 : " prop="empName" size="small">
                                            <span>{{props.row.empName}}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="性别 : " prop="empSex" size="small">
                                            <span>{{props.row.empSexName}}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="手机号码 : " prop="tel" size="small">
                                            <span>{{props.row.tel}}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-col>
                                <el-col>
                                    <el-row>
                                        <el-col :span="8">
                                            <el-form-item label="证件类型 : " prop="idType" size="small">
                                                <span>{{props.row.idTypeName}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="证件号码 : " prop="idNumber" size="small">
                                                <span>{{props.row.idNumber}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="职称 : " prop="title" size="small">
                                                <span>{{props.row.title}}</span>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                    <el-row>
                                        <el-col :span="8">
                                            <el-form-item label="毕业院校 : " prop="school" size="small">
                                                <span>{{props.row.school}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="专业 : " prop="major" size="small">
                                                <span>{{props.row.major}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="最高学历 : " prop="education" size="small">
                                                <span>{{props.row.educationName}}</span>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="8">
                                            <el-form-item label="是否在职 : " prop="offjob" size="small">
                                                <span>{{props.row.offJobName}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="入职时间 : " prop="workTime" size="small">
                                                <span>{{props.row.workTime | dateStrIntercept}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="公司职务 : " prop="job" size="small">
                                                <span>{{props.row.job}}</span>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col>
                                            <el-form-item label="从业开始时间 : " prop="workStartTime" size="small">
                                                <span>{{props.row.workStartTime | dateStrIntercept}}</span>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col>
                                            <el-form-item label="从业经历 : " prop="workExperience" size="small">
                                                <span>{{props.row.workExperience}}</span>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col>
                                            <el-form-item label="身份证件信息 : " prop="fileList1" size="small">
                                                <docUploadView
                                                        :index="props.$index"
                                                        :type="type"
                                                        :isDown="true"
                                                        :docItem.sync="props.row.attachmentParamList[0]"
                                                        :fileLists.sync="ruleForm.fileList1"
                                                />
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col>
                                            <el-form-item label="社保证明 : " prop="fileList2" size="small">
                                                <docUploadView
                                                        :index="props.$index"
                                                        :type="type"
                                                        :isDown="true"
                                                        :docItem.sync="props.row.attachmentParamList[1]"
                                                        :fileLists.sync="ruleForm.fileList2"
                                                />
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </el-form>
                        <span @click="toogleExpand(props.row)"
                              style="position: absolute; bottom: 16px; right: 17px; font-weight: 400; color: #1890FF; font-size: 14px; cursor: pointer;">
                                    收起<i class="el-icon-arrow-up" style="color: #1890FF;margin-left: 4px;"></i>
                                </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    export default {
        name: "basic-information-personnel",
        data(){
            return{
                id:'',
                getRowKeys(row) {
                    return row.id
                },
                // 要展开的行，数值的元素是row的key值
                expands: [],
                type: 'ent_base_info',
                ruleForm: {
                    empName: '',
                    empSex: '',
                    tel: '',
                    idType: '',
                    idNumber: '',
                    title: '',
                    school: '',
                    major: '',
                    education: '',
                    offjob: '',
                    workTime: '',
                    job: '',
                    workStartTime: '',
                    workExperience: '',
                    attachmentParamList: [{//附件列表
                        Id: "",
                        citeId: "",
                        name: "",
                        fileType: 1,
                        filePath: "",
                        required: false,
                        attributes: {
                            attname: "",
                            delmethod: "2",
                            allows: '.pdf,.PDF'
                        }
                    },{//附件列表
                        Id: "",
                        citeId: "",
                        name: "",
                        fileType: 1,
                        filePath: "",
                        required: false,
                        attributes: {
                            attname: "",
                            delmethod: "2",
                            allows: '.pdf,.PDF'
                        }
                    }],
                    fileList1: [],
                    fileList2: [],
                },
                currentPage:1,
                pageSize:10,
                total:0,
                rules:{
                    empName: [
                        {required: true, message: '请输入姓名', trigger: 'blur'},
                    ],
                    empSex: [
                        {required: true, message: '请选择性别', trigger: 'change'},
                    ],
                    tel: [
                        {required: true, message: '请输入手机号码', trigger: 'blur'},
                    ],
                    idType: [
                        {required: true, message: '请选择证件类型', trigger: 'blur'},
                    ],
                    idNumber: [
                        {required: true, message: '请输入证书号码', trigger: 'blur'},
                    ],
                    title: [
                        {required: true, message: '请输入职称', trigger: 'blur'},
                    ],
                    school: [
                        {required: true, message: '请输入毕业院校', trigger: 'blur'},
                    ],
                    major: [
                        {required: true, message: '请输入专业', trigger: 'blur'},
                    ],
                    education: [
                        {required: true, message: '请输入最高学历', trigger: 'blur'},
                    ],
                    offjob: [
                        {required: true, message: '请选择是否在职', trigger: 'change'},
                    ],
                    workTime: [
                        {required: true, message: '请选择入职时间', trigger: 'change'},
                    ],
                    job: [
                        {required: true, message: '请输入公司职务', trigger: 'blur'},
                    ],
                    workStartTime: [
                        {required: true, message: '从选择从业时间', trigger: 'change'},
                    ],
                    workExperience: [
                        {required: true, message: '请输入从业经历', trigger: 'blur'},
                    ],
                    fileList1: [
                        {required: true, message: '请上传财务会计报表', trigger: 'change'},
                    ],
                    fileList2: [
                        {required: true, message: '请上传企业完税附件', trigger: 'change'},
                    ],
                },
                tableList: [],
                queryParameter:{
                    attachmentParamList:[],
                    isValidate:'',
                    id:'',
                    fromId:'',
                    entId:'',
                    entRoleCode	:'',
                    empName:'',
                    empSex:'',
                    birthDate:'',
                    idType:'',
                    idNumber:'',
                    regionAddress:'',
                    isFullTime:'',
                    school:'',
                    education:'',
                    graduationTime:'',
                    major:'',
                    schoolYear:'',
                    tel:'',
                    offjob:'',
                    offjobtime:'',
                    workTel:'',
                    zipCode:'',
                    workStartTime:'',
                    socialSecurityNo:'',
                    postalAddress:'',
                    otherContactInformation:'',
                    department:'',
                    job:'',
                    titleNo:'',
                    title:'',
                    workYear:'',
                    workExperience:'',
                    state:'',
                    remark:'',
                    delFlag:'',
                    createUser:'',
                    createTime:'',
                    updateUser:'',
                    updateTime:'',
                    oldEntId:'',
                    cancelFlag:'',
                    cancelTime:'',
                    workTime:'',
                    comeFrom:'',
                }
            }
        },
        created() {
            this.getRouterQuery();
            this.querData();
        },
        activated() {
            this.getRouterQuery();
            this.querData();
        },
        methods: {
            getRouterQuery(){
                this.id = this.$route.query.id;
            },
            // 获取数据
            querData(){
                this.$http.post('/portal/item/listemp/'+this.id,{
                    page:this.currentPage,
                    rows:this.pageSize,
                    filter:{
                        key:''
                    },
                    searchKey: '',
                    orderBy:'create_time desc'
                }).then((res)=>{
                    if(res.data){
                        this.tableList = res.data.rows;
                        this.total = res.data.total;
                        if (this.tableList.length && this.tableList[0].state == 4) {
                            this.expands.push(this.tableList[0].id)
                        }
                    }
                })
            },
            // 查看
            toogleExpand(row) {
                this.$refs.table.toggleRowExpansion(row)
            },
            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.querData();
            }
        },
        filters:{
            dateStrIntercept(str){
                if(str){
                    return str.substring(0,11);
                }else{
                    return '--'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-textarea__inner {
        width: 690px;
        height: 80px;
    }
    .card-content {
        .card-content-search {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            padding-top: 4px;
            margin-right: 12px;

            .card-content-search-input {
                width: 250px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 2px;
                outline: none;
            }

            .card-content-search-btn {
                width: 70px;
                height: 32px;
                background: #1890FF;
                border: none;
                border-radius: 2px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 32px;
                cursor: pointer;
            }

            .card-content-search-add {
                width: 82px;
                height: 32px;
                background: #1890FF;
                border: none;
                border-radius: 2px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                cursor: pointer;
                line-height: 32px;
                margin-left: 12px;
            }
            .card-content-search-add-able {
                width: 82px;
                height: 32px;
                background: #1890FF;
                border: none;
                border-radius: 2px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                cursor: pointer;
                line-height: 32px;
                margin-left: 12px;
                opacity: 25%;
            }
        }

        .card-content-table {
            margin: 16px 12px 0 12px;
        }
    }
</style>